import axios from 'axios';

import ConfigureHeaders from '../utils/ConfigureHeaders';

const baseURL = process.env.REACT_APP_BOX_API_ENDPOINT;
const frontURL = process.env.REACT_APP_SENTINELA_FRONT_END;

const box = () => {
  const defaultOptions = {
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(config => ConfigureHeaders(config));

  instance.interceptors.response.use(
    response => response,
    err => {
      if (err.response.status === 401) {
        sessionStorage.clear();

        const { origin } = window.location;
        const redirectURL = `redirectURL=${origin}&toLocation=/`;

        return window.location.assign(`${frontURL}/#/login?${redirectURL}&fromApplication=16`);
      }

      return Promise.reject(err);
    },
  );

  return instance;
};

export default box();
